// 封包外層編解碼 — 對應 Unity Gateway PacketCmd（送出）/ ResponseInfo（回應）。
// 送出與回應的欄位佈局不同，分別處理。
import { gatewayType } from './proto/gatewayProto'

export interface OutPacket {
  readonly cmd: string
  readonly requestId: string
  readonly data: Uint8Array
}

export interface ResponsePacket {
  readonly code: number
  readonly message: string
  readonly cmd: string
  readonly requestId: string
  readonly txnId: string
  readonly balance: bigint
  readonly currency: string
  readonly data: Uint8Array
  readonly totalWin: bigint
}

interface RawResponse {
  Code?: number
  Message?: string
  Cmd?: string
  RequestId?: string
  TxnId?: string
  Balance?: string
  Currency?: string
  Data?: Uint8Array
  TotalWin?: string
}

export function encodePacket(packet: OutPacket): Uint8Array {
  const type = gatewayType('PacketCmd')
  const message = type.create({ Cmd: packet.cmd, RequestId: packet.requestId, Data: packet.data })
  return type.encode(message).finish()
}

export function decodeResponse(bytes: Uint8Array): ResponsePacket {
  const type = gatewayType('ResponseInfo')
  const raw = type.toObject(type.decode(bytes), {
    longs: String,
    bytes: Uint8Array,
    defaults: true,
  }) as RawResponse
  return {
    code: raw.Code ?? 0,
    message: raw.Message ?? '',
    cmd: raw.Cmd ?? '',
    requestId: raw.RequestId ?? '',
    txnId: raw.TxnId ?? '',
    balance: BigInt(raw.Balance ?? '0'),
    currency: raw.Currency ?? '',
    data: raw.Data ?? new Uint8Array(0),
    totalWin: BigInt(raw.TotalWin ?? '0'),
  }
}
